import { useNavigate } from 'react-router';

import { useExperienceFlags } from '@hcs/experience-flags';
import { ORDER_MANAGER_URL } from '@hcs/urls';

import { APP_CONFIG_AGILE_SUITE, VIEW_PATHS_ORDER_MANAGER } from '../constants';

export const useNavigateToAgileSuite = () => {
  const navigate = useNavigate();
  const EXPERIENCE_FLAGS = useExperienceFlags();
  return () => {
    if (EXPERIENCE_FLAGS.ORDER_MANAGER) {
      navigate(
        `${APP_CONFIG_AGILE_SUITE.rootPath}${VIEW_PATHS_ORDER_MANAGER.ORDERS}/`
      );
    } else {
      window.location.assign(ORDER_MANAGER_URL);
    }
  };
};
